import { AppointmentTimeSlotsForPlan } from "@rumble-it/common-lib/types/models/AppointmentTimeSlotsForPlan.interface.ts";
import { axiosInstance } from "./client";

export const getAppointmentTimeSlotsByServicePartner = async (
  servicePartnerId: string,
) =>
  axiosInstance
    .get<AppointmentTimeSlotsForPlan>(
      `/driver/appointment-time-slots/available-at-service-partner/${servicePartnerId}?dossierType=repair_direct.generic`,
    )
    .then((response) => response.data);
